import { baseApi } from 'app/baseApi';

// ==============================|| AUTH - API ||============================== //

export const authApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    login: builder.mutation({
      query: (credentials) => ({ url: 'auth/login', method: 'POST', body: credentials })
    }),
    refresh: builder.mutation({
      query: (refreshToken) => ({ url: 'auth/refresh', method: 'POST', body: { refreshToken } })
    }),
    logout: builder.mutation({
      query: (refreshToken) => ({ url: 'auth/logout', method: 'POST', body: { refreshToken } })
    }),
    getMe: builder.query({
      query: () => 'auth/me',
      providesTags: ['Me']
    }),
    changeMyPassword: builder.mutation({
      query: (body) => ({ url: 'auth/me/password', method: 'POST', body })
    })
  }),
  overrideExisting: false
});

export const { useLoginMutation, useRefreshMutation, useLogoutMutation, useGetMeQuery, useChangeMyPasswordMutation } = authApi;
